import { PageRenderer } from "@diality/ui";
import { CmsPageView } from "../../src/marketing/CmsPageView";
import { data, useLoaderData } from "react-router";
import type { LoaderFunctionArgs } from "react-router";
import { marketingPageLoader } from "../../src/marketing/page-loader";
import type { MarketingPageLoaderData } from "../../src/marketing/page-loader";
import { NotFoundPage } from "../../src/pages/marketing/NotFoundPage";

export { marketingMeta as meta } from "../../src/marketing/seo";

/**
 * Catch-all: a CMS-published page, or a real 404.
 *
 * A page authored in the CMS is reachable at its own url without a route entry
 * here — the route table only has to name the paths that still have a hardcoded
 * component behind them. Unmatched paths render the NotFoundPage inside the site
 * chrome AND return a 404 status, so crawlers don't index soft-404s.
 */
export async function loader(args: LoaderFunctionArgs) {
  const result = await marketingPageLoader(args);
  return data(result, { status: result.kind === "cms" ? 200 : 404 });
}

export default function CmsPageOrNotFound() {
  const page = useLoaderData() as MarketingPageLoaderData | undefined;

  if (page?.kind !== "cms") {
    return <NotFoundPage />;
  }

  return (
    <CmsPageView data={page}>
      <PageRenderer blocks={page.blocks} />
    </CmsPageView>
  );
}
